import React, { PropTypes } from 'react';
import { NitroHeading, NitroButton, NitroDivider, NitroPanel, NitroParagraph, NitroIcon, } from 'nitro-components';

import Status from '../../components/utils/Status';

import styled from 'styled-components';
import { media } from 'style-utils';

const Heading = styled.div`
  margin: 20px 0;
  display: flex;
  justify-content: center;
`;

const Panel = styled.div`
  text-align: center;
  min-height: 20px;
  margin-top: 40px;
`;

const PanelContent = styled.div`
  margin: 10px auto;
  max-width: 50%;
  ${media.mobile`
    max-width: 100%;
  `}
`;

const Message = styled.div`
  margin: 10px 0 10px;
  color: red;
`;

const SimpleError = ({ headindText, messageDetail }) => {
    return (
        <div>
            <Panel>
                <NitroPanel>

                    <Heading>
                        <NitroIcon name="red-black-warning" size={22} />
                        <NitroHeading style={{ marginLeft: "0.7rem" }} label={headindText} variant="secondary" align="center" size="1" />
                    </Heading>
                    <PanelContent>

                        <Message>
                            <NitroParagraph style={{ color: "red" }} variant="base3" align="center">{messageDetail}</NitroParagraph>
                        </Message>
                    </PanelContent>

                </NitroPanel>
            </Panel>
        </div>
    );
};

SimpleError.propTypes = {
    headindText: PropTypes.string.isRequired,
    messageDetail: PropTypes.string.isRequired,
    formattedErrorStatus: PropTypes.object.isRequired,
    closeWindow: PropTypes.func,
    actionHandler: PropTypes.object
};

export default SimpleError;



// WEBPACK FOOTER //
// ./src/features/errors/SimpleError.js